<template>

	<div class="portlet portlet-participants box grey-cascade">

		<div class="portlet-title">

			<div class="caption">Participantes</div>

		</div>

		<div class="portlet-body">

			<div class="table-responsive">

				<table class="table table-hover table-striped m-b-0">
					<tbody>
						<tr v-for="mgu in users">
							<td>{{ mgu.user.name }}</td>
						</tr>
					</tbody>
				</table>

			</div>

			<hr>

			<form v-on:submit.prevent="onSubmit" role="form">

				<div class="form-group m-b-0">

					<label for="participant" v-translate>Adicionar participante</label>

					<div class="input-group">

						<select name="participant" id="participant" v-model="newParticipant" class="form-control" v-validate="'required'" required>

							<option value="" v-translate>Selecione</option>

							<optgroup v-for="(participant, index) in participants" :label="participant.title">

								<option v-for="value in participant.list" :value="value.userId">
									{{ value.formatedName }}
								</option>

							</optgroup>

						</select>

						<span class="input-group-btn">

							<button type="submit" class="btn btn-success" :disabled="errors.items.length > 0" v-translate>
								Adicionar
							</button>

						</span>

					</div>

				</div>

			</form>

		</div>

	</div>

</template>

<style lang="scss" scoped>

	.portlet-participants {

		.table-hover tbody tr:hover > td,
		.table-hover tbody tr:hover > th,
		.table-striped tbody > tr:nth-child(odd) > td,
		.table-striped tbody > tr:nth-child(odd) > th {
			cursor: default;
		}

	}

</style>

<script>

	import MessageUsers from './';
	export default MessageUsers;

</script>




// WEBPACK FOOTER //
// main.vue?91605060